import { Tooltip } from '@shared/components/popover/tooltip';
import { inventoryCases, type Product } from '../../../data/product';
import { formatCasesQuantity } from '../../../helpers/format-quantity';
import { StatusCell } from '../../status/status-cell';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const QOHCases: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'QOH Cases',
  minWidth: 50,
  accessorFn: (product) => formatCasesQuantity(product.inventory_qty, product.case_qty),
  toCSV: (product) => ({
    'QOH Cases': product.case_qty ? inventoryCases(product).toFixed(2) : '',
  }),
  cell: ({ item: product, value }) => {
    if (product.inventory_qty < 0) {
      return (
        <Tooltip content="Inventory is negative, accurate counts are required for ordering.">
          <StatusCell variant="danger">{value}</StatusCell>
        </Tooltip>
      );
    }

    return <span className="text-accent-500 font-semibold tabular-nums">{value}</span>;
  },
  gloss: 'Cases in inventory as of your last count.',
});
